import brand from '@helpers/brand';
import styled from 'styled-components';
const Title = styled.h2 `
  --highlightColour: ${brand.primary.teal.teal100};

  

  /* Background.Teal */
  &[data-text='teal'] {
    --highlightColour: ${brand.primary.teal.teal100};
  }

  /* Background.Pear */
  &[data-text='pear'] {
    --highlightColour: ${brand.primary.pear.pear100};
  }

  /* Background.Blue */
  &[data-text='blue'] {
    --highlightColour: ${brand.primary.blue.blue100};
  }

  /* Background.DarkBlue */
  &[data-text='dark-blue'] {
    --highlightColour: ${brand.accent.darkBlue.darkBlue100};
  }

  /* Background.ForrestGreen */
  &[data-text='forrest-green'] {
    --highlightColour: ${brand.accent.forrestGreen.forrestGreen100};
  }

  /* Background.Purple */
  &[data-text='purple'] {
    --highlightColour: ${brand.secondary.purple.purple100};
  }

  /* Background.Yellow */
  &[data-text='yellow'] {
    --highlightColour: ${brand.secondary.yellow.yellow100};
  }

  /* .Orange */
  &[data-text='orange'] {
    --highlightColour: ${brand.secondary.orange.orange100};
  }

  &[data-text='engage-green'] {
    --highlightColour: ${brand.engagePrimary.green.green100};
  }

  &[data-text='engage-sea-green'] {
    --highlightColour: ${brand.engagePrimary.seaGreen.seaGreen100};
  }
  
  &[data-text='engage-teal'] {
    --highlightColour: ${brand.engagePrimary.teal.teal100};
  }

  &[data-text='engage-lime'] {
    --highlightColour: ${brand.engagePrimary.lime.lime100};
  }

  &[data-text='engage-sky'] {
    --highlightColour: ${brand.engagePrimary.sky.sky100};
  }

  &[data-text='engage-purple'] {
    --highlightColour: ${brand.engageSecondary.purple.purple100};
  }

  &[data-text='engage-lilac'] {
    --highlightColour: ${brand.engageSecondary.lilac.lilac100};
  }

  &[data-text='engage-tangerine'] {
    --highlightColour: ${brand.engageSecondary.tangerine.tangerine100};
  }

  &[data-text='engage-lavender'] {
    --highlightColour: ${brand.engageSecondary.lavender.lavender100};
  }

  &[data-text='engage-pink'] {
    --highlightColour: ${brand.engageSecondary.pink.pink100};
  }

  &[data-text='engage-yellow'] {
    --highlightColour: ${brand.engageSecondary.yellow.yellow100};
  }

  &[data-text='bronze'] {
    --highlightColour: ${brand.awards.bronze.bronze100};
  }

  &[data-text='silver'] {
    --highlightColour: ${brand.awards.silver.silver100};
  }

  &[data-text='gold'] {
    --highlightColour: ${brand.awards.gold.gold100};
  }

  &[data-type='engage'] {
    --highlightColour: ${brand.engagePrimary.seaGreen.seaGreen100};
    color: ${brand.engagePrimary.seaGreen.seaGreen100};

    span {
      color: ${brand.global.white};
      text-decoration: none;
      background-color: var(--highlightColour);
      padding: 4px 30px;
      border-radius: 48px;
    }
  }

  span {
    color: var(--highlightColour);
    text-decoration: underline;
  }
`;
const HighlightTitleStyles = {
    Title,
};
export default HighlightTitleStyles;
